import { Component, ElementRef, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { EMRService } from 'app/EMR/EMR.service';
import { Observable, Subject } from 'rxjs';
import { map, startWith, takeUntil } from 'rxjs/operators';
import { SearchcategoryComponent } from './searchcategory/searchcategory.component';

@Component({
  selector: 'app-categorymaster',
  templateUrl: './categorymaster.component.html',
  styleUrls: ['./categorymaster.component.scss']
})
export class CategorymasterComponent implements OnInit {
  // private enabledisablebtnMstCatDia: boolean = true;
  destroydiagcat$: Subject<boolean> = new Subject<boolean>();
  private showspinner: boolean = false;
  private departmentName: string = "";
  private CategoryName: string = "";
  private CategoryCode: string = "";
  private departmentid: number = 0;
  private categoryid: number = 0;
  private isActive: boolean = true;
  private surgerydepartments_ds: any = [];
  private DepartmentCtrl: FormControl;
  private filteredDeptArray: Observable<any[]>;
  private disableupdatebutton: boolean = true;
  private daigonisCategory: any = [];
  enabledisablebtn: boolean = false;
  isheader: boolean = false;
  @ViewChild('departmentRef', { static: false }) private DepartmentRef: ElementRef;
  @ViewChild('categoryNameRef', { static: false }) private CategoryNameRef: ElementRef;
  @ViewChild('categoryCodeRef', { static: false }) private CategoryCodeRef: ElementRef;
  constructor(private dialog: MatDialog, private dashboardService: DashboardService,
    private emrservice: EMRService,
    private dialogRef: MatDialogRef<CategorymasterComponent>, @Optional() @Inject(MAT_DIALOG_DATA) private data: any,) {
    dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    this.daigonisCategory = [];
    this.surgerydepartments_ds = [];
    this.disableupdatebutton = true;
    this.showspinner = false;
    this.departmentName = "";
    this.CategoryCode = "";
    this.departmentid = 0;
    this.categoryid = 0;
    this.isActive = true;
    this.getDepartmentList();
    this.departmentControll();
    this.getDiagonisisCategory(0);
    if (this.data) {
      this.isheader = this.data.isheader;
    } else {
      this.isheader = false;
    }
  }
  cleardata() {
    // this.daigonisCategory = [];
    // this.surgerydepartments_ds = [];
    this.disableupdatebutton = true;
    this.showspinner = false;
    this.departmentName = "";
    this.CategoryCode = "";
    this.CategoryName = "";
    this.departmentid = 0;
    this.categoryid = 0;
    this.isActive = true;
  }
  ngOnDestroy() {

    this.destroydiagcat$.next(true);
    this.destroydiagcat$.unsubscribe();
    this.daigonisCategory = null;
    this.surgerydepartments_ds = null;
    this.disableupdatebutton = null;
    this.showspinner = null;
    this.departmentName = null;
    this.CategoryCode = null;
    this.departmentid = null;
    this.categoryid = null;
    this.isActive = null;
  }
  closedialog() {
    this.dialogRef.close(0);
  }
  //get diagonsis category
  getDiagonisisCategory(diaid) {
    this.emrservice.GetDiagonisCategory(diaid).pipe(takeUntil(this.destroydiagcat$)).subscribe(data => this.sucees_dagonis(data), err => this.err_daigonsis(err));
  }

  sucees_dagonis(data) {
    if (data.length > 0) {
      this.daigonisCategory = data;
    }

  }
  err_daigonsis(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    } else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }
  //get depatment list
  getDepartmentList() {
    this.emrservice.GetdiagonsisDept().pipe(takeUntil(this.destroydiagcat$)).subscribe(data => this.successdepart(data), err => this.failed_depart(err))
  }

  successdepart(data) {
    this.surgerydepartments_ds = data.filter(item => item.isActive == true);
    this.departmentControll();
  }
  failed_depart(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    } else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }
  //autocomplet
  departmentControll() {

    this.DepartmentCtrl = new FormControl();
    this.filteredDeptArray = this.DepartmentCtrl.valueChanges
      .pipe(
        startWith(''),
        map(cat => cat ? this.filterdoctorfunction(cat) : this.surgerydepartments_ds.slice())
      );

  }

  filterdoctorfunction(name: string) {
    const filterValue = name.toString().toLowerCase();
    return this.surgerydepartments_ds.filter(country =>
      country.deptName?.toLowerCase().indexOf(filterValue) === 0);

  }

  getDepartmentobj(e: any) {
    var val = e.option.value;
    this.departmentName = val.deptName;
    this.departmentid = val.pK_DeptID;
    // this.enabledisablebtnMstCatDia =false;
  }

  CheckinputDept(event: any) {

    var checkdata = event.target.value;
    if (checkdata == "") {
      this.departmentControll();
      this.departmentid = 0;
      this.departmentName = "";
    }
  }
  openSearchCategory(): void {
    const dialogRef = this.dialog.open(SearchcategoryComponent, {
      panelClass: 'full-width-dialog',
      maxWidth: '95vw',
      width: '95%',
      disableClose: true,
      data: {
        // enabledisablebtnMstCatDia:this.enabledisablebtnMstCatDia
      }
    });
    dialogRef.afterClosed().pipe(takeUntil(this.destroydiagcat$)).subscribe(result => {
      if (result != 0) {
        this.disableupdatebutton = false;
        this.categoryid = result.pk_DiagnosisCatId;
        this.CategoryName = result.categoryName;
        this.CategoryCode = result.icdCode;
        this.departmentName = result.department;
        this.isActive = result.isActive;
      }
    });
  }

  Changediatype() {
    // this.enabledisablebtnMstCatDia =false;
  }

  Changediatcatype($event) {
    // this.enabledisablebtnMstCatDia =false;
    // this.daigonisCategory.categoryName = $event.target.value;
  }
  ChangeCategory(e: any, type: any) {
    switch (type) {
      case (1): {
        // this.enabledisablebtnMstCatDia =false;
        this.CategoryName = e;
        break;
      }
      case (2): {
        // this.enabledisablebtnMstCatDia =false;
        this.CategoryCode = e;
        break;
      }
      case (3): {
        if (e == false) {
          this.isActive = true;
          // this.enabledisablebtnMstCatDia =false;
        } else {
          this.isActive = false;
          // this.enabledisablebtnMstCatDia =false;
        }
        break;
      }
    }
  }
  clearData() {
    this.disableupdatebutton = true;
    this.departmentName = "";
    this.CategoryName = "";
    this.CategoryCode = "";
    this.departmentid = 0;
    this.categoryid = 0;
    this.isActive = false;
  }
  // check validation 
  categoryCodeValidation: boolean = false;
  categoryNameValidation: boolean = false;
  departmentNameValidation: boolean = false;

  addNewCategory(event) {
    // const button = (event.srcElement.disabled === undefined) ? event.srcElement.parentElement : event.srcElement;
    // button.setAttribute('disabled', true);
    // setTimeout(function () {
    //   button.removeAttribute('disabled');
    // }, 1000);
    if (this.departmentName != "") {
      if (this.CategoryName != "") {
        if (this.CategoryCode != "") {
          if (this.departmentName === 'Ophthalmology' || this.departmentName === 'Dental') {
            if (this.categoryid > 0) {
              let payloaddata = {
                "DiagnosisCategoryMaster": {
                  "IsEdit": true,
                  "IsDelete": false,
                  "Pk_DiagnosisCatId": this.categoryid,
                  "CategoryName": this.CategoryName,
                  "Department": this.departmentName,
                  "ICDCode": this.CategoryCode,
                  "IsActive": this.isActive,
                  "PK_SynchId": 1,
                }

              }
              this.emrservice.InsertDiagnosisCategoryMaster(payloaddata).pipe(takeUntil(this.destroydiagcat$)).subscribe((x: any) => {
                if (x['statusCode'] == 1) {
                  // this.emrservice.enabledisablebtnDia=true;
                  // this.enabledisablebtnMstCatDia = true;
                  this.dashboardService.openSnackBar("Record Updated Successfully", "OK");
                  this.clearData();
                  this.getDiagonisisCategory(0);
                }
              }, err => {
                if (err.status == 403) {
                  this.dashboardService.openSnackBar("You Don't have Permission", "OK");
                }
                else if (err.error.statusCode == 422) {
                  this.dashboardService.openSnackBar(err.error.message, "OK");
                }
                else {
                  this.dashboardService.openSnackBar("API Failed", "OK");
                }
              })

            } else {
              const checkcatename = this.daigonisCategory.filter(item => item.categoryName.toLowerCase() === this.CategoryName.toLowerCase());
              if (checkcatename.length > 0) {
                this.dashboardService.openSnackBar("Category name is already exists", "OK");
                // this.CategoryName = "";
              } else {
                let payloaddata = {
                  "DiagnosisCategoryMaster": {
                    "IsEdit": false,
                    "IsDelete": false,
                    "Pk_DiagnosisCatId": 0,
                    "CategoryName": this.CategoryName,
                    "Department": this.departmentName,
                    "ICDCode": this.CategoryCode,
                    "IsActive": this.isActive,
                    "PK_SynchId": 1,
                  }

                }
                this.emrservice.InsertDiagnosisCategoryMaster(payloaddata).pipe(takeUntil(this.destroydiagcat$)).subscribe((x: any) => {
                  if (x['statusCode'] == 1) {
                    // this.enabledisablebtnMstCatDia = true;
                    this.dashboardService.openSnackBar("Record Saved Successfully", "OK");
                    this.getDiagonisisCategory(0);
                    this.clearData()
                  }
                }, err => {
                  if (err.status == 403) {
                    this.dashboardService.openSnackBar("You Don't have Permission", "OK");
                  }
                  else if (err.error.statusCode == 422) {
                    this.dashboardService.openSnackBar(err.error.message, "OK");
                  }
                  else {
                    this.dashboardService.openSnackBar("API Failed", "OK");
                  }
                })
              }
            }
          } else {
            this.dashboardService.openSnackBar(" Please Select Correct Department", "OK");
          }
        } else {
          this.dashboardService.openSnackBar("Please Select Category Code", "OK");
          setTimeout(() => {
            this.CategoryCodeRef.nativeElement.focus();
          }, 100);
          this.categoryCodeValidation = true;
        }
      } else {
        this.dashboardService.openSnackBar("Please Select Category Name", "OK");
        setTimeout(() => {
          this.CategoryNameRef.nativeElement.focus();
        }, 100);
        this.categoryNameValidation = true;
      }
    } else {
      this.dashboardService.openSnackBar("Please Select Department Name", "OK");
      setTimeout(() => {
        this.DepartmentRef.nativeElement.focus();

      }, 100);
      this.departmentNameValidation = true;
    }
  }
  Cancelpopup(type) {
    if (type == 1) {
      document.getElementById("daignosiscatModal").style.display = "Block";
    } else {
      document.getElementById("daignosiscatModal").style.display = "None";
    }

  }


}
